exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nimg.success-img {\n  width: 0.71rem;\n  height: 0.5rem;\n  margin-top: 1.17rem;\n  margin-bottom: 0.45rem;\n}\n.success-content {\n  text-align: center;\n}\n.success-title {\n  font-size: 0.3rem;\n  color: #272f44;\n  margin-bottom: 0.9rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0b639c1c","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/personalCenter/updateSuccess.vue
// module id = 145
// module chunks = 1 2